import styled from "styled-components";
import { Card } from "@material-ui/core";

export const CardStyled = styled(Card)`
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: ${(props) => props.theme.palette.background.main};
  background-clip: border-box;
  box-shadow: 1px 2px 2px 0px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  padding: 5px;
  margin-bottom: 20px;
  border-top: 1px solid ${(props) => props.theme.palette.primary.main};
`;
